module.exports = __webpack_public_path__ + "images/goudse_smalld0854e9b92693b119f04e918156eac52.png";